// extracted by mini-css-extract-plugin
export default {"layout":"main_layout__Kph87","content":"main_content__EAqch"};